import { createAction } from 'redux-actions';

export const showAlert = createAction('SHOW_ALERT');
export const closeAlert = createAction('CLOSE_ALERT');
export const setExecuted = createAction('SET_EXECUTED');
